export const GET_EEA_VERSIONS = 'GET_EEA_VERSIONS';
